import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

export const CommonService = {
  getYearList() {
    var startYear = 2023;
    var endYear = 2055;
    var years = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push({ name: year, code: year });
    }
    return years;
  },
  getStartDate() {

    var startYear = localStorage.getItem('startYear');
    if (!startYear) {
      return ""
    }
    return startYear;
  },
  getEndDate() {

    var endYear = localStorage.getItem('endYear');
    if (!endYear) {
      return ""
    }
    return endYear;
  },
  getColorDeclarationComponent() {
    var t = [{
      name: "Site Visit Stage Color",
      code: "#f4cccc"
    },
    {
      name: "CE Stage Color",
      code: "#fce5cd"
    },
    {
      name: "FSA Stage Color",
      code: "#fff2cc"
    },
    {
      name: "Contract Stage Color",
      code: "#cb9a34"
    },
    {
      name: "Construction Start Stage Color",
      code: "#d9ead3"
    },
    {
      name: "Turned Down Color",
      code: "#d9d2e9"
    },
    {
      name: "NOT PROCEEDING FSA Color",
      code: "#b79bf8"
    }, {
      name: "Lost/ Not Proceeding Color",
      code: "#ead1dc"
    }, {
      name: "Other Color",
      code: "#ff0000"
    },

    ]

    return (
      <DataTable value={t} tableStyle={{ minWidth: '300px', border: "none" }} size="large">
        <Column field="name"></Column>
        <Column body={(e) => <div style={{ minWidth: "30px", minHeight: "30px", backgroundColor: e.code }}></div>}></Column>


      </DataTable>
    );
  },

  getProjectBlankData() {
    return {
      id: '',
      project_name: '',
      project_type: '',
      contact_date: '',
      fsa_date: '',
      contract_date: '',
      est_start_date: '',
      est_complete_date: '',
      act_start_date: '',
      act_complete_date: '',
      esitmatedSales: '',
      fixed_price: '',
      fixed_month: '',
      hours_per_day: '',
      project_manager: '',
      project_status: '',
      orig_expected_gp: '',
      project_cost_per: '',
      actual_to_date: '',
      actual_fees: '',
      project_progress: '',
      deleted: '',
      created_at: '',
      modify_at: '',
      contract_amount: '',
      year: '',
      month: '',
      status_on_em_playbooks: '',
      fsa_signed_date_em_playbook: '',
      forecasted_building_date_em_playbook: '',
      building_permit_recieved_em_playbook: '',
      actual_pre_con_month_by_day_em_playbook: '',
      of_pre_con_month_by_day_em_playbook: '',
      actual_pre_con_month_em_playbook: '',
      actual_start_date_pm: '',
      forecasted_complation_data_pm: '',
      actual_complation_date_pm: '',
      actual_slippage_of_month_dat_pm: '',
      slippage_of_month_by_day_pm: '',
      forecasted_month_pm: '',
      actual_month_pm: '',
      actaulMonth: '',
      estimatedMonth: '',
      startDate: '',
      completionData: '',
      monthLeft: '',
      orig_gp_month: '',
      newExpectedGP: '',
      updatedGPMonth: '',
      gpTermofProjectperMonth: '',
      gpTermofProject: '',
      perofGPSlippage: '',
      projectCostFees: '',
      margin: '',
      feesTotal: '',
      feesToDate: '',
      feesLeft: '',
      fessPerMonth: '',
      directCostRemaining: '',
      directcostperMonth: '',
      fixedPrice: '',
      Month_Data: '',
      complete: '',
      revenueEarnedToDate: '',
      overallPersanatage: '',
      overUnderBilling: '',
      contact_to_fsa_month_by_day: '',
      fsa_to_contract_month_by_day: '',
      fsa_to_construction_start_month_by_day: '',
    }
  }
}
